import React from "react";
import { Box, Typography } from "@mui/material";
import { SelectChangeEvent } from "@mui/material/Select";
import Dropdown from "src/components/shared/molecules/dropdown";
import useStyles from "./Styles";

interface HeaderProps {
  selectedChannel: string;
  handleChangeChannel: (event: SelectChangeEvent) => void;
}

const Header: React.FC<HeaderProps> = ({
  selectedChannel,
  handleChangeChannel,
}) => {
  const { classes } = useStyles();

  const menuItemData = [
    {
      label: "Facebook",
      value: "facebook",
    },
    {
      label: "WhatsApp",
      value: "whatsapp",
    },
    {
      label: "Instagram",
      value: "instagram",
    },
    {
      label: "Chatbot",
      value: "chatbot",
    },
  ];

  return (
    <Box className={classes.headerBox}>
      <Typography className={classes.headerText}>Pages Breakdown</Typography>
      <Dropdown
        usersSelectValue={selectedChannel}
        handleChangeSelect={handleChangeChannel}
        options={menuItemData}
      />
    </Box>
  );
};

export default Header;
